import React from 'react';

import { Anchor } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';
import { ApiKeysTable } from 'pages/Settings/SettingTabs/ApiKeysTable';
import { SettingsSectionWrapper } from 'pages/Settings/SettingTabs/SettingsSectionWrapper';
import { useTranslation } from 'react-i18next';

const API_DOC_URL = 'https://docs.droxy.ai/api-reference/introduction';

export function ApiSettingsTab() {
  const { t } = useTranslation();

  return (
    <SettingsSectionWrapper
      h="100%"
      title={t('API.TABLE.TITLE')}
      rightComponent={
        <Anchor href={API_DOC_URL} td="underline" target="_blank" ml={15} mt={-15}>
          {t(`API.DOCUMENTATION`)}
          <IconExternalLink style={{ height: 16, width: 16, marginLeft: 5, float: 'right' }} />
        </Anchor>
      }>
      <ApiKeysTable isZapierKey={false} h="100%" />
    </SettingsSectionWrapper>
  );
}
